import React from 'react'
import { FormattedMessage } from 'react-intl'
import clipboardCopy from 'clipboard-copy'
import { Link } from '@contrast-security-inc/design-system-typography'
import { css } from '@emotion/css'

export interface CopyButtonProps {
  readonly stringToCopy: string
  readonly onClick: () => void
  readonly buttonTranslationID?: string
}

export function CopyButton({
  stringToCopy,
  onClick,
  buttonTranslationID = 'action_copy'
}: CopyButtonProps) {
  return (
    <FormattedMessage id={buttonTranslationID}>
      {(copyMsg) => (
        <Link
          className={css`
            font-size: 12px;
          `}
          onClick={async () => {
            await clipboardCopy(stringToCopy)
            onClick()
          }}
        >
          {copyMsg}
        </Link>
      )}
    </FormattedMessage>
  )
}
